import { AppTeamUtil } from '../../core/app-team-util';
import { Member } from '../member/member.model';
import { ImageAsset } from '../images/image-asset-model';

export class Child
{
    BirthDate?: Date;
    CategoryIds: number[] = [];
    FaceDetectionSamples: ImageAsset[] = [];
    FirstName?: string;
    Id!: number;
    LastName?: string;
    Members: Member[] = [];
    DetectedImages: ImageAsset[] = [];
	ActiveYears: number[] = [];

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            this.BirthDate = AppTeamUtil.convertApiDateStringToDate(json['BirthDate'])!;
            if (json.FaceDetectionSamples) this.FaceDetectionSamples = json.FaceDetectionSamples.map((json: any) => new ImageAsset(json));
            if (json.DetectedImages) this.DetectedImages = json.DetectedImages.map((json: any) => {
                const ia = new ImageAsset(json.ImageAsset);
                ia.Confidence = json.Confidence;
                return ia;
            });
            if (json.Members) this.Members = json.Members.map((json: any) => new Member(json));
            return;
        }
    }

    public get fullName(): string { return `${this.FirstName} ${this.LastName}`; }
    public get fullNameLastFirst(): string { return `${this.LastName} ${this.FirstName}`; }
}
